import {
  CREATE_USER,
  EDIT_USER,
  DELETE_USER,
  CHECK_USER_SCHOOL,
  TOP_BAR_USER_INFO,
  GLOBAL_SEARCH,
  GET_ONLINE_USERS,
  BASE_URL,
} from "../util/constants";
import axios from "axios";
import { sendRequest } from "./base";

export const createUser = async (data, token) => {


  const Authorization = `Bearer ${token}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization,
    },
    data: data,
    url: `${BASE_URL}/${CREATE_USER}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;
    throw new Error("Something went wrong please try again");
  } catch (error) {
    throw new Error(error);
  }

};



// export const createUser = async (data, token) => {
//   //return data;
//   const Authorization = `Bearer ${token}`;
//   try {
//     return sendRequest(data, "POST", CREATE_USER, { Authorization });
//   } catch (err) {
//     return err;
//   }
// };

export const editUser = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "PUT", `${EDIT_USER}?id=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};

export const deleteUser = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "DELETE", `${DELETE_USER}?id=${id}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};
export const searchUsers = async (SearchValue, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "POST",
      `${CHECK_USER_SCHOOL}?searchBy=${SearchValue}`,
      {
        Authorization,
      }
    );
  } catch (error) {
    return error;
  }
};
export const checkUserSchool = async (data, page, token, limit) => {
  const Authorization = `Bearer ${token}`;

  try {
    return sendRequest(
      data,
      "POST",
      `${CHECK_USER_SCHOOL}?page=${page + 1}&pageSize=${limit}`,
      { Authorization }
    );
  } catch (error) {
    return error;
  }
};

export const topBarInfo = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", TOP_BAR_USER_INFO, { Authorization });
  } catch (error) {
    return error;
  }
};

export const globalSearches = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", `${GLOBAL_SEARCH}`, { Authorization });
  } catch (error) {
    return error;
  }
};

export const getOnlineUser = async (schoolId, role, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    const users = sendRequest(
      null,
      "GET",
      `${GET_ONLINE_USERS}?schoolId=${schoolId}&role=${role}`,
      { Authorization }
    );
    //alert(users);
    return users;
  } catch (error) {
    return error;
  }
};
